// extracted by css-extract-rspack-plugin
export default {"cls1":"FeedbackForm-cls1_bhE","cls2":"FeedbackForm-cls2_N35 FeedbackForm-cls1_bhE"};